/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CountryDeliveryCharges,
  CountryWrapperResource,
  GetDeliveryCharges500,
  GetDeliveryChargesParams,
  GetDeliveryChargesServer500,
  GetDeliveryChargesServerParams,
  GetProductDeliveryPromiseByIdServer500,
  GetProductDeliveryPromiseByIdServerParams,
  GetReturnCountries500,
  GetReturnCountriesServer500,
  PdpPromiseDTO,
  Save2500,
  Save2Server500,
} from '@as-react/common-types/delivery-service';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType, BodyType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Find a delivery charge
 */
export const useGetDeliveryChargesHook = () => {
  const getDeliveryCharges = useQueryFetch<CountryDeliveryCharges>();

  return useCallback(
    (
      params: GetDeliveryChargesParams,
      operationName = 'getDeliveryCharges',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getDeliveryCharges(
        { url: `/api/deliverycharges/`, method: 'GET', params, signal },
        { operationName: 'getDeliveryCharges', ...options }
      );
    },
    [getDeliveryCharges]
  );
};

export const useGetDeliveryChargesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
  TError = ErrorType<GetDeliveryCharges500>,
>(
  params: GetDeliveryChargesParams,
  operationName = 'getDeliveryCharges',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/deliverycharges/`, queryOptions });

  const getDeliveryCharges = useGetDeliveryChargesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>> = ({ signal }) =>
    getDeliveryCharges(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliveryChargesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>
>;
export type GetDeliveryChargesQueryError = ErrorType<GetDeliveryCharges500>;

export function useGetDeliveryCharges<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
  TError = ErrorType<GetDeliveryCharges500>,
>(
  params: GetDeliveryChargesParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryCharges<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
  TError = ErrorType<GetDeliveryCharges500>,
>(
  params: GetDeliveryChargesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryCharges<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
  TError = ErrorType<GetDeliveryCharges500>,
>(
  params: GetDeliveryChargesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find a delivery charge
 */

export function useGetDeliveryCharges<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>,
  TError = ErrorType<GetDeliveryCharges500>,
>(
  params: GetDeliveryChargesParams,
  operationName = 'getDeliveryCharges',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryChargesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetDeliveryChargesQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save a delivery charge
 */
export const useSave2Hook = () => {
  const save2 = useQueryFetch<void>();

  return useCallback(
    (
      countryDeliveryCharges: BodyType<CountryDeliveryCharges>,
      operationName = 'save2',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return save2(
        {
          url: `/api/deliverycharges/`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: countryDeliveryCharges,
          signal,
        },
        { operationName: 'save2', ...options }
      );
    },
    [save2]
  );
};

export const useSave2MutationOptions = <TError = ErrorType<Save2500>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSave2Hook>>>,
    TError,
    { data: BodyType<CountryDeliveryCharges>; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSave2Hook>>>,
  TError,
  { data: BodyType<CountryDeliveryCharges>; operationName?: string },
  TContext
> => {
  const mutationKey = ['save2'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const save2 = useSave2Hook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSave2Hook>>>,
    { data: BodyType<CountryDeliveryCharges>; operationName?: string }
  > = props => {
    const { data, operationName } = props ?? {};

    return save2(data, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type Save2MutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSave2Hook>>>>;
export type Save2MutationBody = BodyType<CountryDeliveryCharges>;
export type Save2MutationError = ErrorType<Save2500>;

/**
 * @summary Save a delivery charge
 */
export const useSave2 = <TError = ErrorType<Save2500>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useSave2Hook>>>,
      TError,
      { data: BodyType<CountryDeliveryCharges>; operationName?: string },
      TContext
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSave2Hook>>>,
  TError,
  { data: BodyType<CountryDeliveryCharges>; operationName?: string },
  TContext
> => {
  const mutationOptions = useSave2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Find a delivery charge
 */
export const getDeliveryChargesServer = (
  params: GetDeliveryChargesServerParams,
  operationName = 'getDeliveryCharges',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<CountryDeliveryCharges>(
    { url: `/deliverycharges`, method: 'GET', params, signal },
    { operationName: 'getDeliveryCharges', ...options }
  );
};

export const useGetDeliveryChargesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliveryChargesServer>>,
  TError = ErrorType<GetDeliveryChargesServer500>,
>(
  params: GetDeliveryChargesServerParams,
  operationName = 'getDeliveryCharges',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryChargesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/deliverycharges`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeliveryChargesServer>>> = ({ signal }) =>
    getDeliveryChargesServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliveryChargesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliveryChargesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getDeliveryChargesServer>>>;
export type GetDeliveryChargesServerQueryError = ErrorType<GetDeliveryChargesServer500>;

export function useGetDeliveryChargesServer<
  TData = Awaited<ReturnType<typeof getDeliveryChargesServer>>,
  TError = ErrorType<GetDeliveryChargesServer500>,
>(
  params: GetDeliveryChargesServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryChargesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryChargesServer>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryChargesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryChargesServer<
  TData = Awaited<ReturnType<typeof getDeliveryChargesServer>>,
  TError = ErrorType<GetDeliveryChargesServer500>,
>(
  params: GetDeliveryChargesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryChargesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryChargesServer>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryChargesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryChargesServer<
  TData = Awaited<ReturnType<typeof getDeliveryChargesServer>>,
  TError = ErrorType<GetDeliveryChargesServer500>,
>(
  params: GetDeliveryChargesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryChargesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find a delivery charge
 */

export function useGetDeliveryChargesServer<
  TData = Awaited<ReturnType<typeof getDeliveryChargesServer>>,
  TError = ErrorType<GetDeliveryChargesServer500>,
>(
  params: GetDeliveryChargesServerParams,
  operationName = 'getDeliveryCharges',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryChargesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetDeliveryChargesServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save a delivery charge
 */
export const save2Server = (
  countryDeliveryCharges: CountryDeliveryCharges,
  operationName = 'save2',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<void>(
    {
      url: `/deliverycharges`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: countryDeliveryCharges,
      signal,
    },
    { operationName: 'save2', ...options }
  );
};

export const getSave2ServerMutationOptions = <TError = ErrorType<Save2Server500>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof save2Server>>,
    TError,
    { data: CountryDeliveryCharges; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof save2Server>>,
  TError,
  { data: CountryDeliveryCharges; operationName?: string },
  TContext
> => {
  const mutationKey = ['save2Server'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof save2Server>>,
    { data: CountryDeliveryCharges; operationName?: string }
  > = props => {
    const { data, operationName } = props ?? {};

    return save2Server(data, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type Save2ServerMutationResult = NonNullable<Awaited<ReturnType<typeof save2Server>>>;
export type Save2ServerMutationBody = CountryDeliveryCharges;
export type Save2ServerMutationError = ErrorType<Save2Server500>;

/**
 * @summary Save a delivery charge
 */
export const useSave2Server = <TError = ErrorType<Save2Server500>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof save2Server>>,
      TError,
      { data: CountryDeliveryCharges; operationName?: string },
      TContext
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof save2Server>>,
  TError,
  { data: CountryDeliveryCharges; operationName?: string },
  TContext
> => {
  const mutationOptions = getSave2ServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Find delivery promises based on product id and sku id
 */
export const getProductDeliveryPromiseByIdServer = (
  market: string,
  shopId: number,
  productId: number,
  params: GetProductDeliveryPromiseByIdServerParams,
  operationName = 'getProductDeliveryPromiseById',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<PdpPromiseDTO>(
    { url: `/deliverypromise/pdp/v3/${market}/${shopId}/${productId}`, method: 'GET', params, signal },
    { operationName: 'getProductDeliveryPromiseById', ...options }
  );
};

export const useGetProductDeliveryPromiseByIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
  TError = ErrorType<GetProductDeliveryPromiseByIdServer500>,
>(
  market: string,
  shopId: number,
  productId: number,
  params: GetProductDeliveryPromiseByIdServerParams,
  operationName = 'getProductDeliveryPromiseById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, shopId, productId, params, operationName },
    { url: `/deliverypromise/pdp/v3/${market}/${shopId}/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>> = ({ signal }) =>
    getProductDeliveryPromiseByIdServer(market, shopId, productId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(market && shopId && productId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductDeliveryPromiseByIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>
>;
export type GetProductDeliveryPromiseByIdServerQueryError = ErrorType<GetProductDeliveryPromiseByIdServer500>;

export function useGetProductDeliveryPromiseByIdServer<
  TData = Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
  TError = ErrorType<GetProductDeliveryPromiseByIdServer500>,
>(
  market: string,
  shopId: number,
  productId: number,
  params: GetProductDeliveryPromiseByIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductDeliveryPromiseByIdServer<
  TData = Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
  TError = ErrorType<GetProductDeliveryPromiseByIdServer500>,
>(
  market: string,
  shopId: number,
  productId: number,
  params: GetProductDeliveryPromiseByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
          TError,
          Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProductDeliveryPromiseByIdServer<
  TData = Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
  TError = ErrorType<GetProductDeliveryPromiseByIdServer500>,
>(
  market: string,
  shopId: number,
  productId: number,
  params: GetProductDeliveryPromiseByIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find delivery promises based on product id and sku id
 */

export function useGetProductDeliveryPromiseByIdServer<
  TData = Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>,
  TError = ErrorType<GetProductDeliveryPromiseByIdServer500>,
>(
  market: string,
  shopId: number,
  productId: number,
  params: GetProductDeliveryPromiseByIdServerParams,
  operationName = 'getProductDeliveryPromiseById',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductDeliveryPromiseByIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetProductDeliveryPromiseByIdServerQueryOptions(
    market,
    shopId,
    productId,
    params,
    operationName,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find delivery countries
 */
export const useGetReturnCountriesHook = () => {
  const getReturnCountries = useQueryFetch<CountryWrapperResource>();

  return useCallback(
    (
      mainWebShop: string,
      webShopId: number,
      operationName = 'getReturnCountries',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnCountries(
        { url: `/api/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, method: 'GET', signal },
        { operationName: 'getReturnCountries', ...options }
      );
    },
    [getReturnCountries]
  );
};

export const useGetReturnCountriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebShop, webShopId, operationName },
    { url: `/api/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const getReturnCountries = useGetReturnCountriesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>> = ({ signal }) =>
    getReturnCountries(mainWebShop, webShopId, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnCountriesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>
>;
export type GetReturnCountriesQueryError = ErrorType<GetReturnCountries500>;

export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find delivery countries
 */

export function useGetReturnCountries<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>,
  TError = ErrorType<GetReturnCountries500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnCountriesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnCountriesQueryOptions(mainWebShop, webShopId, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find delivery countries
 */
export const getReturnCountriesServer = (
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<CountryWrapperResource>(
    { url: `/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, method: 'GET', signal },
    { operationName: 'getReturnCountries', ...options }
  );
};

export const useGetReturnCountriesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebShop, webShopId, operationName },
    { url: `/deliverycharges/countries/returnportal/${mainWebShop}/${webShopId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnCountriesServer>>> = ({ signal }) =>
    getReturnCountriesServer(mainWebShop, webShopId, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebShop && webShopId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnCountriesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnCountriesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnCountriesServer>>>;
export type GetReturnCountriesServerQueryError = ErrorType<GetReturnCountriesServer500>;

export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnCountriesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnCountriesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnCountriesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnCountriesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find delivery countries
 */

export function useGetReturnCountriesServer<
  TData = Awaited<ReturnType<typeof getReturnCountriesServer>>,
  TError = ErrorType<GetReturnCountriesServer500>,
>(
  mainWebShop: string,
  webShopId: number,
  operationName = 'getReturnCountries',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnCountriesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnCountriesServerQueryOptions(mainWebShop, webShopId, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
